import {
  useRecordContext,
} from "react-admin";
import {
    Button as MUIButton,
    Stack,
    MenuItem, Link
} from "@mui/material";
import {ServiceOfferingEnums} from "../../enums/ServiceOfferingEnums";
import React, {useCallback, useEffect, useState} from "react";
import {ShowCookSlotsDialog} from "../Common/ShowCookSlotsDialog";
import {MarkLeaveDialog} from "../Common/MarkLeaveDialog";
import {CookService} from "../../services/CookServices";
import {ShowCookSlcDialog} from "../Common/ShowCookSlcDialog";
import {BulkBlockCookSlotsDialog} from "../Common/BulkBlockCookSlotsDialog";
import CityService from "../../services/CityService";
import AreaService from "../../services/AreaService";
import CityResponse from "../../interfaces/City/CityResponse";
import AreaResponse from "../../interfaces/Area/AreaResponse";
import CommonListTable, { CommonListColumn } from "../Common/CommonListTable";

//Common styles
import {
    FilterContainer,
    FilterInput,
    FilterSection,
    FilterTextField,
    FilterWrapper,
    FIlterHeader,
    SectionHeader,
    SectionTitle,
    WorkspaceContainer,
    WorkSpaceTitleRow,
} from "../../styles/commonStyles";
import { FilterIcon } from "../Svg";

interface InputProps {
  name: any,
  callback: (data: any) => void,
  color?: "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning" | undefined
}

const CustomButton = (props: InputProps) => {
  let record = useRecordContext();
  return (
      <MUIButton
          onClick={() => {
            props.callback(record);
          }}
          variant={'contained'}
          size={"small"}
          color={props.color || "secondary"}
          style={{ width: "max-content", fontSize: "12px" }}
      >
        {props.name}
      </MUIButton>
  )
}

export const RenderCTAButtons = (props: any) => {
  return(
      <Stack direction={"row"} gap={2}>
        <CustomButton
          name={'all SLC'}
          callback={() => {
              props.setSelectedData(props?.data);
              props.setShowSlc(true);
          }}
        />
        {/* <CustomButton
            color={'error'}
            name={'Mark / UnMark leave'}
            callback={() => {
              props.setSelectedData(props?.data);
              props.setMarkLeave(true);
            }}
        /> */}
        <CustomButton
            name={'Show Slots'}
            callback={() => {
              props.setSelectedData(props?.data);
              props.setShowSlots(true);
            }}
        />
      </Stack>
  )
}

const cookService = new CookService();
const cityService = new CityService();
const areaService = new AreaService();

const DailyCooksSlots = (props: any) => {
    const [page, setPage] = React.useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);
    const [total, setTotal] = React.useState<number>(0);

    let [selectedData, setSelectedData] = useState<any>(null);
    let [showSlots, setShowSlots] = useState<boolean>(false);
    let [showSLc, setShowSlc] = useState<boolean>(false);
    let [services, setServices] = useState<any>([]);

    const [cityList, setCityList] = useState<CityResponse[]>([]);
    const [selectCity, setSelectCity] = useState<any>(1);
    const [allAreaList, setAllAreaList] = useState<AreaResponse[]>([]);
    const [areaList, setAreaList] = useState<AreaResponse[]>([]);
    const [selectAreaId, setSelectAreaId] = useState<number | null>(null);
    const [cookId, setCookId] = useState<number | string | null>(null);

    let [markLeave, setMarkLeave] = useState<boolean>(false)
    let [bulkBlock, setBulkBlock] = useState<boolean>(false);
    let [data, setData] = useState<any>([]);

    useEffect(() => {
        cityService.fetchAllCities(100, 0, {isCurrentlyServing:"YES"}, {}).then((res) => {
            setCityList(res?.data);
        });
        areaService.fetchAllAreas(100, 0, {}, {}).then((res) => {
            setAllAreaList(res?.data);
            setAreaList(res?.data);
        })
    }, [])

    useEffect(() => {
        if(!selectCity) {
            setAreaList(allAreaList);
            return;
        }
        setAreaList([]);
        // setSelectAreaId(null);
        areaService.fetchAllAreas(100, 0, {
            cityId: selectCity,
        }, {}).then((res) => {
            setAreaList(res?.data);
            setSelectAreaId(null);
            // setSelectAreaId(res?.data?.[0]?.id || 0);
        })
    }, [allAreaList, selectCity])

    const loadData = useCallback((limit: number, offset: number, filter: any) => {
        cookService.getAllDailyCooks(limit, offset, filter).then((res: any) => {
            setTotal(res?.total || 0);
            setData([...res?.data]);
        })
    }, []);

    useEffect(() => {
        let filter = {};
        if(cookId) {
            filter = {
                cookId
            }
        } else {
            filter = {
                cityId: selectCity,
                serviceId: services?.length ? services : [1, 2, 3, 4],
            }
            if(selectAreaId) {
                filter = {
                    ...filter,
                    areaId: selectAreaId,
                }
            }
        }

       loadData(rowsPerPage, page*rowsPerPage, filter)
    }, [loadData, page, rowsPerPage, services, selectCity, selectAreaId, cookId]);

    const columns: CommonListColumn[] = [
        {
            label: "Id",
            render: (row: any) => (
                <Link href={`/#/Cooks/${row?.cook?.cookId}/show/`}>
                    {row?.cook?.cookId}
                </Link>
            ),
        },
        {
            label: "Name",
            render: (row: any) => `${row?.cook?.firstName} ${row?.cook?.lastName}`,
        },
        { label: "Cook Type", field: "cook.cookType" },
        {
            label: "Service",
            render: (row: any) =>
                Object.keys(ServiceOfferingEnums)?.[row?.serviceId - 1] || '---',
        },
        {
            label: "Action",
            stopRowClick: true,
            render: (row: any) => (
                <RenderCTAButtons
                    setSelectedData={setSelectedData}
                    setShowSlots={setShowSlots}
                    setMarkLeave={setMarkLeave}
                    setShowSlc={setShowSlc}
                    data={row?.cook}
                />
            ),
        },
    ];

  return (
    <>
        {showSlots && (
            <ShowCookSlotsDialog
                data={selectedData}
                open={showSlots}
                callback={() => {
                    setShowSlots(false);
                }}
            />
        )}
        {showSLc && (
            <ShowCookSlcDialog
                data={selectedData}
                open={showSLc}
                callback={() => {
                    setShowSlc(false);
                }}
            />
        )}
        {markLeave && (
            <MarkLeaveDialog
                data={selectedData}
                open={markLeave}
                callback={() => {
                    setMarkLeave(false);
                }}
            />
        )}
        {bulkBlock && (
            <BulkBlockCookSlotsDialog
                open={bulkBlock}
                callback={() => {
                    setBulkBlock(false);
                }}
            />
        )}
        <WorkspaceContainer sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {/* ── Filters ── */}
            <FilterWrapper>
                <FIlterHeader>
                    <FilterSection style={{ marginBottom: "0" }}>
                        <SectionHeader>
                            <WorkSpaceTitleRow>
                                <FilterIcon color="#1976d2" height={20} width={20} />
                                <SectionTitle>Filters</SectionTitle>
                            </WorkSpaceTitleRow>
                        </SectionHeader>
                        <MUIButton
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
                            onClick={() => setBulkBlock(true)}
                        >
                            Bulk Block Slots
                        </MUIButton>
                    </FilterSection>
                </FIlterHeader>

                <FilterContainer style={{ flexWrap: 'wrap', rowGap: '12px' }}>
                    <FilterTextField
                        select
                        label="Service"
                        size="small"
                        variant="outlined"
                        value={services}
                        onChange={(e: any) => {
                            setServices(e.target.value as string);
                        }}
                        SelectProps={{ multiple: true }}
                        sx={{ minWidth: 200 }}
                    >
                        {Object.keys(ServiceOfferingEnums).map((key,index) => (
                            <MenuItem key={key} value={index + 1}>
                                {key}
                            </MenuItem>
                        ))}
                    </FilterTextField>

                    <FilterTextField
                        select
                        label="City"
                        size="small"
                        variant="outlined"
                        value={selectCity ?? ""}
                        onChange={(event: any) => {
                            let value: any = event.target.value
                            setSelectCity(value);
                        }}
                        sx={{ minWidth: 150 }}
                    >
                        {cityList.map((eachCity) => (
                            <MenuItem key={eachCity?.name} value={eachCity?.id}>
                                {eachCity?.name}
                            </MenuItem>
                        ))}
                    </FilterTextField>

                    <FilterTextField
                        select
                        label="Area"
                        size="small"
                        variant="outlined"
                        value={selectAreaId ?? ""}
                        onChange={(event: any) => {
                            let value: any = event.target.value
                            setSelectAreaId(value);
                        }}
                        sx={{ minWidth: 150 }}
                    >
                        {areaList.map((eachCity) => (
                            <MenuItem key={eachCity?.name} value={eachCity?.id}>
                                {eachCity?.name}
                            </MenuItem>
                        ))}
                    </FilterTextField>

                    <FilterInput
                        value={cookId ?? ""}
                        type="number"
                        size="small"
                        variant="outlined"
                        onChange={(event) => {
                            let val = event.target.value;
                            if(val === '') {
                                setCookId('');
                            } else {
                                if (/^-?\d*\.?\d*$/.test(val) && parseFloat(val) >= 0) {
                                    setCookId(Number(event.target.value));
                                }
                            }
                        }}
                        label="Cook Id"
                        InputProps={{ inputProps: { min: 0 } }}
                    />
                </FilterContainer>
            </FilterWrapper>

            <br />

            {/* ── List ── */}
            <CommonListTable
                title="Daily Cook Slots"
                columns={columns}
                data={data ?? []}
                loading={false}
                page={page}
                rowsPerPage={rowsPerPage}
                total={total || 0}
                onPageChange={setPage}
                onRowsPerPageChange={(rows) => {
                    setRowsPerPage(rows);
                    setPage(0);
                }}
                fillHeight
            />
        </WorkspaceContainer>
    </>
  );
};

export default DailyCooksSlots;
